import React from "react";
import icons from "../icons";
import { handleError } from '../services/authApiRoutes/APImethods';

export default function AppErrorPage(props) {

const navigateBack = () => {
    window.location.href='/';
}

if(props.error){
    handleError(props.error);
}


  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <div className="wrapper">
              <div className="sign-page">
                <div className="content">

                <div className="back">
                    <button  onClick={navigateBack}>
                        <i aria-hidden="true"></i>Back
                     </button>
                </div>

                  <div className="small-container">

                    <div className="logo-block">
                        <a href="/"><img src={icons.OPAL_LOGO} alt="OPAL-Marketing  logo" title="OPAL-Marketing logo" /></a>
                    </div>

                    <div className="inner-content-wrap">
                      <h1>Apologies from OPAL-Marketing</h1>
                       <p>
                       {props?.errorMsg?.length === 0 ? "An unexpected error has occurred.  Please try again later." : props?.errorMsg}
                      </p>

                      <div className="image-block bgTransparent">
                        <img src={icons.ERROR_ICON} alt="Password Icon" />
                      </div>

                      <p>
                        Go back to your <a href="/">OPAL-Marketing Home</a> to continue working.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              </div>
      </div>
     </div>
  );
}
